export default __webpack_public_path__ + "static/treatmentarea-armsbefore-3bca01dd8c74f8209af74c170d8a5b44.webp";